import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { Modal, Button } from "react-bootstrap";

export default function Galeri() {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMedia, setSelectedMedia] = useState(null);

  useEffect(() => {
    const fetchGaleri = async () => {
      try {
        const q = query(collection(db, "galeri"), orderBy("keterangan", "asc"));
        const snap = await getDocs(q);
        const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setMedia(data);
      } catch (err) {
        console.error("fetch galeri error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchGaleri();
  }, []);

  const handleClose = () => setSelectedMedia(null);
  const handleOpen = (item) => setSelectedMedia(item);

  const handleDownload = async (item) => {
    try {
      const res = await fetch(item.url);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = item.keterangan + (item.type === "foto" ? ".jpg" : ".mp4");
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download gagal:", err);
    }
  };

  if (loading) return <p className="text-center mt-5">Memuat galeri...</p>;
  if (media.length === 0) return <p className="text-center mt-5">Galeri masih kosong</p>;

  return (
    <section className="py-5" style={{ background: "#f0f8ff" }}>
      <div className="container">
        <h3 className="fw-bold mb-4 text-center text-primary">Galeri Sekolah</h3>
        <div className="row g-3 justify-content-center">
          {media.map(item => (
            <div key={item.id} className="col-md-3">
              <div className="card shadow-sm h-100" style={{ cursor: "pointer" }}>
                {item.type === "foto" ? (
                  <img
                    src={item.url}
                    alt={item.keterangan}
                    style={{ width: "100%", height: "180px", objectFit: "cover" }}
                    className="card-img-top"
                    onClick={() => handleOpen(item)}
                  />
                ) : (
                  <video
                    src={item.url}
                    controls
                    style={{ width: "100%", height: "180px", objectFit: "cover" }}
                    onClick={() => handleOpen(item)}
                  />
                )}
                <div className="card-body text-center p-2">
                  <p className="text-muted small mb-0">{item.keterangan}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal Preview */}
        <Modal show={!!selectedMedia} onHide={handleClose} centered size="lg">
          {selectedMedia && (
            <>
              <Modal.Header closeButton>
                <Modal.Title>{selectedMedia.keterangan}</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                {selectedMedia.type === "foto" ? (
                  <img
                    src={selectedMedia.url}
                    alt={selectedMedia.keterangan}
                    style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: "8px" }}
                  />
                ) : (
                  <video
                    src={selectedMedia.url}
                    controls
                    style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: "8px" }}
                  />
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => handleDownload(selectedMedia)}>
                  Download
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                  Tutup
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </div>
    </section>
  );
}
